export default __webpack_public_path__ + "static/media/azure-lb.88f0b26d.svg";